var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#222222"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10219_8485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9359 11.2754C17.6958 11.2754 17.5009 11.0805 17.5009 10.8404C17.5009 9.17464 16.8525 7.60923 15.6751 6.43125C15.5052 6.26133 15.5052 5.98584 15.6751 5.81592C15.845 5.646 16.1205 5.646 16.2905 5.81592C17.632 7.15798 18.3709 8.94269 18.3709 10.8404C18.3709 11.0805 18.176 11.2754 17.9359 11.2754Z",
    fill: "#A6F9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04593 11.2749C5.80581 11.2749 5.61093 11.08 5.61093 10.8399C5.61093 8.94216 6.34988 7.15745 7.69194 5.81592C7.86187 5.646 8.13746 5.646 8.30738 5.81592C8.4773 5.98584 8.4773 6.26143 8.30738 6.43135C7.1294 7.6087 6.48093 9.17411 6.48093 10.8399C6.48093 11.08 6.28605 11.2749 6.04593 11.2749Z",
    fill: "#A6F9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.991 18.9596C10.7915 18.9596 9.81596 17.984 9.81596 16.7846C9.81596 16.5445 10.0108 16.3496 10.251 16.3496C10.4911 16.3496 10.686 16.5445 10.686 16.7846C10.686 17.5044 11.2711 18.0896 11.991 18.0896C12.7107 18.0896 13.296 17.5044 13.296 16.7846C13.296 16.5445 13.4908 16.3496 13.731 16.3496C13.9711 16.3496 14.166 16.5445 14.166 16.7846C14.166 17.984 13.1904 18.9596 11.991 18.9596Z",
    fill: "#A6F9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.776 17.2203H7.20597C6.64619 17.2203 6.1909 16.765 6.1909 16.2053C6.1909 15.9083 6.32026 15.627 6.54593 15.4339C7.42804 14.6885 7.9309 13.6052 7.9309 12.4574V10.8402C7.9309 8.60152 9.75215 6.78027 11.991 6.78027C14.2297 6.78027 16.0509 8.60152 16.0509 10.8402V12.4574C16.0509 13.6052 16.5538 14.6885 17.4302 15.4298C17.6616 15.627 17.7909 15.9083 17.7909 16.2053C17.7909 16.765 17.3357 17.2203 16.776 17.2203ZM11.991 7.65027C10.2318 7.65027 8.8009 9.08112 8.8009 10.8402V12.4574C8.8009 13.8614 8.18557 15.1874 7.11315 16.0939C7.09287 16.1113 7.0609 16.1473 7.0609 16.2053C7.0609 16.2841 7.12707 16.3503 7.20597 16.3503H16.776C16.8548 16.3503 16.9209 16.2841 16.9209 16.2053C16.9209 16.1473 16.8891 16.1113 16.8699 16.0951C15.7963 15.1874 15.1809 13.8614 15.1809 12.4574V10.8402C15.1809 9.08112 13.7501 7.65027 11.991 7.65027Z",
    fill: "#A6F9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.991 7.65004C11.7508 7.65004 11.556 7.45516 11.556 7.21504V5.47504C11.556 5.23492 11.7508 5.04004 11.991 5.04004C12.2311 5.04004 12.426 5.23492 12.426 5.47504V7.21504C12.426 7.45516 12.2311 7.65004 11.991 7.65004Z",
    fill: "#A6F9FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10219_8485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.92,
    height: 13.92,
    fill: "white",
    transform: "translate(5.03999 5.04004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.c16474a211f89f8f370727a5dc63d413.svg";
export { ForwardRef as ReactComponent };